export const providers = ['lynx', 'quai', 'mock'];
//# sourceMappingURL=types.js.map